import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import {PropostaStatus} from '../../../../dtos/EmprestimoDTO';

export const PropostaCard = styled.TouchableOpacity`
  margin: ${RFValue(8)}px 24px 0;
  border-radius: ${RFValue(14)}px;
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
  background-color: ${({theme}) => theme.colors.price_card};
  padding: ${RFValue(14)}px ${RFValue(16)}px;
`;

export const PropostaCardHeader = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${RFValue(10)}px;
`;

export const PropostaCardDate = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
`;

export const PropostaStatusPill = styled.View<{status: PropostaStatus}>`
  padding: ${RFValue(4)}px ${RFValue(10)}px;
  border-radius: ${RFValue(20)}px;
  background-color: ${({theme, status}) => {
    if (status === 'analise') {return theme.colors.gold;}
    if (status === 'reprovada' || status === 'cancelada') {return theme.colors.attention;}
    if (status === 'assinatura') {return theme.colors.loan_banner_bg;}
    if (status === 'assinada' || status === 'aprovada') {return theme.colors.primary;}
    return theme.colors.text;
  }};
`;

export const PropostaStatusText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.loan_banner_text};
`;

export const PropostaCardBody = styled.View``;

export const PropostaCardRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${RFValue(4)}px;
`;

export const PropostaCardLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
`;

export const PropostaCardValue = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const PropostaCardDivider = styled.View`
  height: 1px;
  background-color: ${({theme}) => theme.colors.border};
  margin: ${RFValue(8)}px 0;
`;

export const PropostaCardAction = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-top: ${RFValue(4)}px;
`;

export const PropostaCardActionText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.loan_action_text};
  margin-right: ${RFValue(4)}px;
`;

export const PropostaCardActionIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.loan_action_text};
`;
